/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EditorialPostPillResponse } from '../../models/editorial-post-pill-response';

export interface GetEditorialPostPillById$Params {
  id: number;
  culture?: string;
}

export function getEditorialPostPillById(http: HttpClient, rootUrl: string, params: GetEditorialPostPillById$Params, context?: HttpContext): Observable<StrictHttpResponse<EditorialPostPillResponse>> {
  const rb = new RequestBuilder(rootUrl, getEditorialPostPillById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('culture', params.culture, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EditorialPostPillResponse>;
    })
  );
}

getEditorialPostPillById.PATH = '/api/editorial/post-pills/{id}';
